import { render, staticRenderFns } from "./DeletePrecioModal.vue?vue&type=template&id=819d026e"
import script from "./DeletePrecioModal.vue?vue&type=script&lang=js"
export * from "./DeletePrecioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports